<img class="component absolute rounded flag" src="{{ imageName }}" [style.width.px]="width" />
